export const getTrimmedString = (str: string, count: number) =>
  str?.trim().length > count ? str?.trim().slice(0, count) + '...' : str;
